export const SISTEMA_CONTABLE_MODULE_ID = 5;

export const SISTEMA_CONTABLE_HOME_RESOURCE = {
  id: "INI",
  nameMenu: "Inicio",
  titlePage: "Inicio",
  titleTab: "Inicio",
  menuPadre: null,
};

export const SISTEMA_CONTABLE_DASHBOARD_RESOURCE = {
  id: "MCD",
  nameMenu: "Dashboard",
  titlePage: "Dashboard Contable",
  titleTab: "Dashboard Contable",
  menuPadre: null,
};

export const SISTEMA_CONTABLE_MENU_SECTIONS = [
  {
    title: "Principal",
    items: [
      {
        id: "MCD",
        icon: "🏠",
        nameMenu: "Dashboard",
        titlePage: "Dashboard",
        titleTab: "Dashboard",
      },
    ],
  },
  {
    title: "Operaciones",
    items: [
      {
        id: "MCC",
        icon: "👥",
        nameMenu: "Clientes",
        titlePage: "Clientes",
        titleTab: "Clientes",
      },
      {
        id: "MCF",
        icon: "🧾",
        nameMenu: "Facturas",
        titlePage: "Facturas",
        titleTab: "Facturas",
      },
      {
        id: "MCPC",
        icon: "💰",
        nameMenu: "Pagos & Cobros",
        titlePage: "Pagos & Cobros",
        titleTab: "Pagos & Cobros",
      },
      {
        id: "MCG",
        icon: "🧾",
        nameMenu: "Gastos",
        titlePage: "Gastos",
        titleTab: "Gastos",
      },
      {
        id: "MCN",
        icon: "↩",
        nameMenu: "Notas de Crédito",
        titlePage: "Notas de Crédito",
        titleTab: "Notas de Crédito",
        badgeTone: "danger",
      },
    ],
  },
  {
    title: "Contabilidad",
    items: [
      {
        id: "MCEF",
        icon: "📋",
        nameMenu: "Estados Financieros",
        titlePage: "Estados Financieros",
        titleTab: "Estados Financieros",
      },
      {
        id: "MCR",
        icon: "📈",
        nameMenu: "Reportes",
        titlePage: "Reportes",
        titleTab: "Reportes",
      },
    ],
  },
];
